import { render, staticRenderFns } from "./DistributionInfoList.vue?vue&type=template&id=2334cb66&scoped=true"
import script from "./DistributionInfoList.vue?vue&type=script&lang=js"
export * from "./DistributionInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2334cb66",
  null
  
)

export default component.exports